export type SidebarController = {
    collapseLeftSidebar: () => void;
    openSidebar: () => void;
    openAll: () => void;
};

export type SidebarSetOpen = (value: boolean | ((prev: boolean) => boolean)) => void;

export function closeLeftThenOpenRightSidebar(options: {
    setOpen: SidebarSetOpen;
    workbench: SidebarController;
    delayMs?: number;
}) {
    const { setOpen, workbench, delayMs = 100 } = options;
    setOpen(false);
    workbench.collapseLeftSidebar();
    setTimeout(() => {
        workbench.openSidebar();
    }, delayMs);
}

export function navigateHomeAndOpenRightSidebar(options: {
    setOpen: SidebarSetOpen;
    workbench: SidebarController;
    delayMs?: number;
}) {
    const { setOpen, workbench, delayMs } = options;
    workbench.openAll();
    closeLeftThenOpenRightSidebar({ setOpen, workbench, delayMs });
}


